"use strict";
/* globals module */
/**
 * @module commerceLookupsSubscriptionStatusBatchRoute
 * @description Baasic Commerce Lookups Subscription Status Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var CommerceLookupsSubscriptionStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsSubscriptionStatusBatchRoute, _super);
    function CommerceLookupsSubscriptionStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/subscription-statuses/batch';
        _this.updateRoute = 'commerce/lookups/subscription-statuses/batch';
        _this.deleteRoute = 'commerce/lookups/subscription-statuses/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.create();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.update();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.remove();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsSubscriptionStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsSubscriptionStatusBatchRoute);
    return CommerceLookupsSubscriptionStatusBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsSubscriptionStatusBatchRoute = CommerceLookupsSubscriptionStatusBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
